// Registry of Equestrian Partners events. Each entry powers an immersive page at /events/{slug}.
// Add an event: { slug, img, video (optional /videos/*.mp4), content: { en: {...}, es: {...}, ... } }
// content shape per language:
// { title, overline, sub, facts: [{ k, v }], sections: [{ type: "editorial"|"media", overline?, title?, text?, img? }], cta }
export const EVENTS_REGISTRY = [];

export function getEvent(slug) {
  return EVENTS_REGISTRY.find((e) => e.slug === slug);
}
